import ApiService from './apiService';
import { UserAccountDto } from '../models/user-account';

class UserAccountService extends ApiService {
  private static instance?: UserAccountService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!UserAccountService.instance) {
      UserAccountService.instance = new UserAccountService();
    }
    return UserAccountService.instance;
  }

  getAll(): Promise<UserAccountDto[]> {
    return this.client.get(`/user-accounts`).then((response) => response.data);
  }

  get(id: string): Promise<UserAccountDto> {
    return this.client.get(`/user-accounts/${id}`).then((response) => response.data);
  }

  getByEmail(email: string): Promise<UserAccountDto> {
    return this.client.get(`/user-accounts/by-email/${email}`).then((response) => response.data);
  }

  async create(account: UserAccountDto): Promise<void> {
    delete account.id;
    try {
      await this.client.post(`/user-accounts`, account);
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || '';
      if (
        typeof message === 'string' &&
        message ===
          'Error creating user account - Error: An error occurred while trying to encrypt the provided data. Refer to the inner exception for more information.'
      ) {
        // Swallow the error and return success
        // TODO: kkilinc - keep this here for now, because backend is giving an exception AFTER
        // the user account is created.
        return;
      }
      throw error;
    }
  }

  update(account: UserAccountDto): Promise<void> {
    return this.client.put(`user-accounts/${account.id}`, account);
  }

  delete(id: string): Promise<void> {
    return this.client.delete(`/user-accounts/${id}`);
  }

  async getAvailableFederatedAuthProviders(): Promise<
    { federatedAuthProviderId: string; name: string; authProviderType: number }[]
  > {
    try {
      const response = await this.client.get('/auth/page-data');
      return response.data.authProviders || [];
    } catch (error) {
      console.error('Error fetching federated auth providers:', error);
      return [];
    }
  }
}

export default UserAccountService;
